import styled from '@emotion/styled';
import React from 'react';

// Gradient-border pill matching the Copilot identity (same outer-gradient
// / inner-white treatment as the chat AI bubble). Kept subtle — it repeats
// once per AI-created experience card — so it's an outline, not a filled
// gradient (the nav pill is the loud one).
const Outer = styled('span')<{ size: 'medium' | 'small' }>`
  display: inline-flex;
  align-items: center;
  padding: 1px;
  border-radius: 999px;
  background: ${(p) => p.theme.dado.copilot.gradientHorizontal};
  vertical-align: middle;
`;

const Inner = styled('span')<{ size: 'medium' | 'small' }>`
  display: inline-flex;
  align-items: center;
  gap: ${(p) => (p.size === 'medium' ? 5 : 4)}px;
  padding: ${(p) => (p.size === 'medium' ? '6px 12px' : '5px 10px')};
  border-radius: 999px;
  background: #fff;
  font-size: ${(p) => (p.size === 'medium' ? 12 : 11)}px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  color: ${(p) => p.theme.dado.copilot.purpleAccent};
`;

const Sparkle: React.FC<{ s: number }> = ({ s }) => (
  <svg width={s} height={s} viewBox="0 0 12 12" fill="currentColor" aria-hidden="true">
    <path d="M6 0L7.2 4.8L12 6L7.2 7.2L6 12L4.8 7.2L0 6L4.8 4.8L6 0Z" />
  </svg>
);

export const CopilotBadge: React.FC<
  React.PropsWithChildren<{ size?: 'medium' | 'small' }>
> = ({ size = 'small' }) => (
  <Outer size={size}>
    <Inner size={size}>
      <Sparkle s={size === 'medium' ? 12 : 11} />
      Co-created with Assistant
    </Inner>
  </Outer>
);
